export default function thousandSeparator(num) {
    // Ensure the input is a number
    if (isNaN(num)) {
        return "";
    }

    const numParts = num.toString().split(".");
    const integerPart = numParts[0];
    const decimalPart = numParts.length > 1 ? "." + numParts[1] : "";

    // Handle cases with fewer than three digits
    if (integerPart.length < 4) {
        return integerPart + decimalPart; // No formatting needed
    }

    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);

    // Format the remaining digits with Indian-style commas
    const formattedIntegerPart = otherDigits
        .replace(/\B(?=(\d{2})+(?!\d))/g, ",") + (lastThreeDigits ? "," + lastThreeDigits : "");

    return formattedIntegerPart + decimalPart;
}
